import React from 'react';
import { SvgIconProps } from './type';
import useDesignTokens from '../themes/useDesignTokens';

function SuccessIcon({ width = '56', height = '56' }: Readonly<SvgIconProps>) {
  const tokens = useDesignTokens();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 28C0.5 12.8122 12.8122 0.5 28 0.5C43.1878 0.5 55.5 12.8122 55.5 28C55.5 43.1878 43.1878 55.5 28 55.5C12.8122 55.5 0.5 43.1878 0.5 28Z"
        fill={tokens.colors.bg.success.primary}
      />
      <path
        d="M0.5 28C0.5 12.8122 12.8122 0.5 28 0.5C43.1878 0.5 55.5 12.8122 55.5 28C55.5 43.1878 43.1878 55.5 28 55.5C12.8122 55.5 0.5 43.1878 0.5 28Z"
        stroke={tokens.colors.bg.success.secondary}
      />
      <path
        d="M22.7507 28L26.2507 31.5L33.2507 24.5M39.6673 28C39.6673 34.4434 34.444 39.6667 28.0007 39.6667C21.5573 39.6667 16.334 34.4434 16.334 28C16.334 21.5567 21.5573 16.3334 28.0007 16.3334C34.444 16.3334 39.6673 21.5567 39.6673 28Z"
        stroke={tokens.colors.fg.success.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SuccessIcon;
